import { Control, Controller, FieldValues, Path } from 'react-hook-form'

import { cn } from '@/lib/utils'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../primitives/Select'
import { Label } from '../primitives/Label'

interface SelectOption {
  id: string | number
  title: string
}

interface FormSelectProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  placeholder?: string
  data: SelectOption[]
  rules?: Record<string, unknown>
  disabled?: boolean
  selectSize?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  showLabel?: boolean
}

export function FormSelect<T extends FieldValues>({
  control,
  name,
  label,
  placeholder = 'Seleccionar...',
  data,
  rules,
  disabled = false,
  selectSize = 'md',
  className,
  showLabel = true,
}: FormSelectProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <div className={cn('flex flex-col gap-2', className)}>
          {showLabel && label && (
            <Label htmlFor={name} required={!!rules?.required}>
              {label}
            </Label>
          )}
          <Select
            disabled={disabled}
            onValueChange={field.onChange}
            value={field.value?.toString() || ''}
          >
            <SelectTrigger
              error={!!fieldState.error}
              id={name}
              selectSize={selectSize}
            >
              <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
              {data.map((option) => (
                <SelectItem key={option.id} value={option.id.toString()}>
                  {option.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {fieldState.error && (
            <span className="text-xs text-red-600">
              {fieldState.error.message}
            </span>
          )}
        </div>
      )}
      rules={rules}
    />
  )
}
